import { useEffect, useState } from "react";
import { verifyBalance } from "@form/services/wallet";
import { Token } from "@form/types";

export default function useVerifyBalance(
  token?: Token,
  address?: string,
  amount?: number
) {
  const [verifySuccess, setVerifySuccess] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token || !address || typeof amount === "undefined") {
      setVerifySuccess(false);
      setVerifying(false);
      setError("");
      return;
    }
    setVerifying(true);
    verifyBalance({ token, user_address: address, amount })
      .then((res) => {
        setVerifySuccess(res);
      })
      .catch((e) => {
        setError(e.message);
      })
      .finally(() => {
        setVerifying(false);
      });
  }, [token, address, amount]);

  return {
    verifySuccess,
    verifying,
    error,
  };
}
